const callbackDanish = {
  processing: "Behandler LinkedIn-autorisation...",
  verifying: "Verificerer brugeroplysninger...",
  connecting: "Opretter sikker forbindelse til LinkedIn...",
  gettingProfile: "Henter profiloplysninger...",
  saving: "Gemmer dine oplysninger sikkert...",
  connected: "LinkedIn-konto tilknyttet!",
  loadingSteps: {
    processing: "Behandler autorisation",
    connecting: "Opretter sikker forbindelse",
    profile: "Henter profiloplysninger",
    finishing: "Færdiggør integration"
  },
  waitMessage: "Vent venligst mens vi færdiggør integrationen med din LinkedIn-konto...",
  error: {
    title: "Der opstod en fejl",
    solutions: {
      title: "Mulige løsninger:",
      clearCookies: "Ryd browser-cookies og cache",
      tryBrowser: "Prøv en anden browser (Chrome eller Firefox anbefales)",
      checkCookies: "Sørg for at du ikke har blokeret cookies fra LinkedIn",
      useHttps: "Prøv at tilgå app.nuvik.io direkte via HTTPS"
    },
    backButton: "Tilbage til indstillinger"
  },
  success: {
    title: "LinkedIn-konto tilknyttet!",
    message: "Din LinkedIn-konto er nu tilknyttet Nuvik.io.",
    redirect: "Du omdirigeres automatisk..."
  }
};

export default callbackDanish; 